import base from './base2.repository';
export default {
    index: () => base.get('arls')
}